import React, { useState, useEffect, useRef } from 'react';
import { Select } from 'antd';
import type { SelectProps, LabeledValue } from 'antd/es/select';
import { isEqual } from 'lodash';

import { hr } from '@/api/examinationApi';

/** 获取选项列表 */
const getOptionList = async () => {
  try {
    const res = await hr.list();
    return res.data.map(item => ({ label: item.hrName, value: item.hrId }));
  } catch (e) {
    return [
      { value: '1', label: 'hr1' },
      { value: '2', label: 'hr2' },
    ];
  }
};

/** hooks：前一个值 */
function usePreviousValue(v) {
  const refV = useRef();
  useEffect(() => {
    refV.current = v;
  });
  return refV.current;
}

/** hooks：EffectObj */
function useEffectObj(handler: (...args: any[]) => any, obj) {
  const preV = usePreviousValue(obj);
  useEffect(() => {
    if (!isEqual(obj, preV)) {
      return handler();
    }
  });
}

interface HrSelectProps<T> extends SelectProps<T> {
  getData?: (params?: Record<string, any>) => Promise<LabeledValue[]> | LabeledValue[];
  requestParams?: Record<string, any>;
}

/** hr 列表 */
const HrSelect: React.FC<HrSelectProps<any>> = props => {
  const { getData = getOptionList, requestParams = {}, ...restProps } = props;

  const [options, setOptions] = useState<LabeledValue[]>([]);

  useEffectObj(() => {
    const res = getData(requestParams);
    if (res instanceof Promise) {
      res.then(v => {
        setOptions(v);
      });
    } else {
      setOptions(res);
    }
  }, requestParams);

  return <Select {...restProps} options={options} />;
};

export default HrSelect;
